import styled from '@emotion/styled';

import YenMark from '@/assets/icons/icon_header_nav_balance.svg';
import ToretaMark from '@/assets/icons/icon_header_nav_toretaplus.svg';
import { BalanceType } from '@/layouts/Nav/WalletInfo/index';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const WalletWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'row'],
    alignItems: ['flex-start', 'flex-start', 'flex-start', 'flex-end'],
    width: [
      'calc(100% / 2 - 8px)',
      'calc(100% / 2 - 8px)',
      'calc(100% / 2 - 8px)',
      'inherit',
    ],
    marginLeft: [0, 0, 0, defaultTheme.spacing.xxl],
    button: {
      width: ['100%', '100%', '100%', '102px'],
      height: ['30px', '30px', '46px', '46px'],
      borderRadius: [
        defaultTheme.border.radius.xs,
        defaultTheme.border.radius.xs,
        defaultTheme.border.radius.xs,
        defaultTheme.border.radius.s,
      ],
      marginTop: [
        defaultTheme.spacing.xs,
        defaultTheme.spacing.xs,
        defaultTheme.spacing.xs,
        0,
      ],
    },
  }),
);

export const BalanceInfo = styled.div(() =>
  mq({
    textAlign: ['left', 'left', 'left', 'right'],
    marginRight: defaultTheme.spacing.l,
    '& > p': {
      fontSize: defaultTheme.font.size.xs,
    },
  }),
);

export const BalanceContainer = styled.p(
  (props: { balanceType: BalanceType }) =>
    mq({
      display: 'flex',
      minWidth: ['', '', '', props.balanceType === 'cash' ? '120px' : '96px'],
      justifyContent: ['inherit', 'inherit', 'inherit', 'flex-end'],
      lineHeight: defaultTheme.font.height.base,
    }),
);

export const Balance = styled.p(() =>
  mq({
    fontWeight: 'bold',
    marginTop: defaultTheme.spacing.xs,
    span: {
      display: 'inline-block',
      fontSize: defaultTheme.font.size.m,
      lineHeight: '22px',
    },
  }),
);

export const YenIcon = styled.i(() =>
  mq({
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundImage: `url(${YenMark})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    marginRight: defaultTheme.spacing.xs,
  }),
);

export const ToretaIcon = styled.i(() =>
  mq({
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundImage: `url(${ToretaMark})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    marginRight: defaultTheme.spacing.xs,
  }),
);
